import { render } from "./Usage.vue?vue&type=template&id=ac483d76&scoped=true"
import script from "./Usage.vue?vue&type=script&lang=js"
export * from "./Usage.vue?vue&type=script&lang=js"

import "./Usage.vue?vue&type=style&index=0&id=ac483d76&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac483d76"]])

export default __exports__